import { combineReducers } from "redux";

import campaignPreview from "@redux/reducers/campaignPreview.reducers";
import important from "@redux/reducers/important.reducers";
import importantPreview from "@redux/reducers/importantPreview.reducers";
import lastedDeviceForceSync from "@redux/reducers/lastedDeviceForceSync.reducers";
import lastedForceSync from "@redux/reducers/lastedForceSync.reducers";
import loadingStatus from "@redux/reducers/loadingStatus.reducers";
import mediaList from "@redux/reducers/mediaList.reducers";
import modalStatus from "@redux/reducers/modalStatus.reducers";

export default combineReducers({
  important,
  loadingStatus,
  modalStatus,
  mediaList,
  campaignPreview,
  importantPreview,
  lastedForceSync,
  lastedDeviceForceSync,
});
